import { IInputProps } from "@interfaces";
import { useController } from "react-hook-form";
import { SelectButton, SelectButtonProps } from "primereact/selectbutton";

import { Field } from "../../field";

//! ANTES DE MODIFICAR ESTE COMPONENTE CONSULTE CON SUS DESARROLLADORES.
//! ANTES DE MODIFICAR ESTE COMPONENTE CONSULTE CON SUS DESARROLLADORES.
//! ANTES DE MODIFICAR ESTE COMPONENTE CONSULTE CON SUS DESARROLLADORES.

export interface ISelectButtonProps
  extends IInputProps,
    Omit<SelectButtonProps, "name" | "defaultValue"> {}

const $SelectButton = ({
  name,
  label,
  rules,
  disabled,
  helperText,
  defaultValue,
  disabledInput,
  fieldClassName,
  shouldUnregister,
  ...props
}: ISelectButtonProps) => {
  const { field, fieldState } = useController({
    name,
    rules,
    disabled,
    defaultValue,
    shouldUnregister,
  });

  return (
    <Field
      name={name}
      label={label}
      helperText={helperText}
      className={fieldClassName}
      isRequired={!!rules?.required}
    >
      <SelectButton
        id={field.name}
        {...field}
        {...props}
        disabled={disabledInput}
        invalid={fieldState.invalid}
      />
    </Field>
  );
};

export default $SelectButton;
